import React, { useState } from 'react';
import { Input, Popover } from 'antd';
import { css } from '@emotion/core';
import { FormattedMessage } from 'react-intl';
import IconSvg from '../../common/IconSvg';

export function PasswordEditor({
  onSave
}) {
  const [newPassword, setNewPassword] = useState('');
  const [passInputVisible, setPassInputVisible] = useState(false);

  return (
    <div
      css={css`
        display: flex;
        align-items: center;
        > *{
          margin-right: 10px;
        }
      `}
    >
      <Popover
        title=""
        content={(<div><FormattedMessage id="settingsModal.updatePassword" /></div>)}
        trigger="hover"
        placement="top"
      >
        <IconSvg size={18} type="pencil" onClick={()=>setPassInputVisible(true)} />
      </Popover>
      {passInputVisible ? (
        <React.Fragment>
          <Input
            value={newPassword}
            onChange={({target:{value}})=>setNewPassword(value)}
            style={{width: '100px'}}
          />
          {newPassword ? (
            <IconSvg
              size={18}
              type="v"
              onClick={()=>{
                onSave(newPassword);
                setNewPassword('')
                setPassInputVisible(false);
              }}
            />
          ) : (
            <div style={{minWidth: '18px'}}>&nbsp;</div>
          )}
          <IconSvg
            size={16}
            type="x"
            onClick={()=>{
              setNewPassword('')
              setPassInputVisible(false)
            }}
          />
        </React.Fragment>
      ) : null}
    </div>
  );
};
